/* CRO2610: the search panel.
   Switch and wording: Theme settings → CRO v3 — Features → Search panel (window.TW_SEARCH, set in
   snippets/cro2610-search.liquid). What the panel lists is drawn on the server by sections/cro2610-search.liquid.

   Phones: a full screen with the field at the top; the keyboard comes up with the first tap, results are rows with
   a picture and stay above the keyboard. Wider screens: a panel from the top of the page, suggestions on the left,
   product cards on the right.

   Header 13 is not edited. The header's own search icon (#searchIcon) keeps its place; a tap on it is taken here
   before the header's older dropdown hears it. With the switch off nothing here runs and the dropdown works as before. */
(function () {
  'use strict';
  var CFG = window.TW_SEARCH || {};
  if (!CFG.on || window.__twSearchOn) return;
  window.__twSearchOn = true;

  var doc = document, html = doc.documentElement;
  var MIN = 2, WAIT = 140, RECENT = 'twsr:recent', RECENT_MAX = 6;
  var root, panel, form, input, clearBtn, body, intro, results, startBox, statusEl;
  var isOpen = false, lastFocus = null, timer = null, ctrl = null, seq = 0, shown = '', cache = {};
  var startHtml = null, startAsked = false;

  function esc(s) { return String(s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function icon(d, size) { return '<svg viewBox="0 0 24 24" width="' + (size || 16) + '" height="' + (size || 16) + '" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' + d + '</svg>'; }
  var I_SEARCH = '<circle cx="11" cy="11" r="6.5"/><path d="M16 16l4.5 4.5"/>';
  var I_CLOSE = '<path d="M6 6l12 12M18 6L6 18"/>';
  var I_BACK = '<path d="M19 12H5M11 6l-6 6 6 6"/>';
  var I_CLOCK = '<circle cx="12" cy="12" r="8.5"/><path d="M12 7.5V12l3 2"/>';
  var I_ARROW = '<path d="M5 12h14M13 6l6 6-6 6"/>';

  // ---- searches made on this device (kept in the browser only)
  function recent() { try { var a = JSON.parse(localStorage.getItem(RECENT) || '[]'); return Array.isArray(a) ? a.filter(function (t) { return typeof t === 'string' && t; }).slice(0, RECENT_MAX) : []; } catch (e) { return []; } }
  function remember(term) {
    term = String(term || '').replace(/\s+/g, ' ').trim().slice(0, 60);
    if (term.length < MIN) return;
    try {
      var a = recent().filter(function (t) { return t.toLowerCase() !== term.toLowerCase(); });
      a.unshift(term);
      localStorage.setItem(RECENT, JSON.stringify(a.slice(0, RECENT_MAX)));
    } catch (e) {}
  }
  function forget() { try { localStorage.removeItem(RECENT); } catch (e) {} }

  // ---- the panel, built once and kept hidden until asked for
  function build() {
    root = doc.createElement('div');
    root.id = 'twSearch';
    root.className = 'tw-sr';
    root.hidden = true;
    root.setAttribute('role', 'dialog');
    root.setAttribute('aria-modal', 'true');
    root.setAttribute('aria-label', 'Search');
    root.innerHTML =
      '<div class="tw-sr__shade" data-tw-sr-close></div>' +
      '<div class="tw-sr__panel">' +
        '<form class="tw-sr__bar" action="' + esc(CFG.searchUrl || '/search') + '" method="get" role="search">' +
          '<div class="tw-sr__barin">' +
            '<button type="button" class="tw-sr__back" data-tw-sr-close aria-label="Close search">' + icon(I_BACK, 22) + '</button>' +
            '<div class="tw-sr__field">' +
              '<span class="tw-sr__glass">' + icon(I_SEARCH, 20) + '</span>' +
              '<input class="tw-sr__input" type="search" name="q" placeholder="' + esc(CFG.placeholder || 'Search') + '" aria-label="' + esc(CFG.placeholder || 'Search') + '" aria-controls="twSearchBody" autocomplete="off" autocorrect="off" autocapitalize="off" spellcheck="false" enterkeyhint="search" maxlength="80">' +
              '<button type="button" class="tw-sr__clear" aria-label="Clear the search" hidden>' + icon(I_CLOSE, 16) + '</button>' +
            '</div>' +
            '<input type="hidden" name="options[prefix]" value="last">' +
            (CFG.productsOnly ? '<input type="hidden" name="type" value="product">' : '') +
            '<button type="button" class="tw-sr__close" data-tw-sr-close><span>Close</span><kbd>esc</kbd></button>' +
          '</div>' +
          '<div class="tw-sr__progress" aria-hidden="true"></div>' +
        '</form>' +
        '<div class="tw-sr__body" id="twSearchBody">' +
          '<div class="tw-sr__in">' +
            '<div class="tw-sr__intro" data-tw-sr-intro></div>' +
            '<div class="tw-sr__results" data-tw-sr-results hidden></div>' +
          '</div>' +
        '</div>' +
        '<p class="tw-sr__status" role="status" aria-live="polite"></p>' +
      '</div>';
    doc.body.appendChild(root);
    panel = root.querySelector('.tw-sr__panel');
    form = root.querySelector('form');
    input = root.querySelector('.tw-sr__input');
    clearBtn = root.querySelector('.tw-sr__clear');
    body = root.querySelector('.tw-sr__body');
    intro = root.querySelector('[data-tw-sr-intro]');
    results = root.querySelector('[data-tw-sr-results]');
    statusEl = root.querySelector('.tw-sr__status');

    input.addEventListener('input', typed);
    clearBtn.addEventListener('click', function () { input.value = ''; typed(); input.focus(); });
    form.addEventListener('submit', function (e) {
      var t = term();
      if (!t) { e.preventDefault(); input.focus(); return; }
      remember(t);
    });
    root.addEventListener('click', clicked);
    root.addEventListener('keydown', keyed);
    // dragging the list on a phone puts the keyboard away, so more of the list shows
    body.addEventListener('touchmove', function () { if (doc.activeElement === input && term()) input.blur(); }, { passive: true });
    if (window.visualViewport) {
      window.visualViewport.addEventListener('resize', fit);
      window.visualViewport.addEventListener('scroll', fit);
    }
  }

  function term() { return input.value.replace(/\s+/g, ' ').trim(); }

  // the part of the screen the keyboard leaves free
  function fit() {
    if (!isOpen || !window.visualViewport) return;
    var vv = window.visualViewport;
    root.style.setProperty('--tw-sr-h', Math.round(vv.height) + 'px');
    root.style.setProperty('--tw-sr-top', Math.round(vv.offsetTop) + 'px');
  }

  // ---- before typing: recent and popular searches, quick links, popular products
  function chip(t, cls, glyph) { return '<button type="button" class="tw-sr__chip' + (cls ? ' ' + cls : '') + '" data-tw-sr-fill="' + esc(t) + '">' + (glyph ? icon(glyph, 14) : '') + '<span>' + esc(t) + '</span></button>'; }
  function drawIntro() {
    var out = '<div class="tw-sr__side">';
    var r = recent();
    if (r.length) {
      out += '<div class="tw-sr__group"><p class="tw-sr__label">Recent<button type="button" class="tw-sr__forget" data-tw-sr-forget>Clear</button></p><div class="tw-sr__chips">' + r.map(function (t) { return chip(t, 'tw-sr__chip--recent', I_CLOCK); }).join('') + '</div></div>';
    }
    var terms = (CFG.terms || []).filter(Boolean);
    if (terms.length) {
      out += '<div class="tw-sr__group"><p class="tw-sr__label">' + esc(CFG.termsTitle || 'Popular searches') + '</p><div class="tw-sr__chips">' + terms.map(function (t) { return chip(t, '', I_SEARCH); }).join('') + '</div></div>';
    }
    var links = (CFG.links || []).filter(function (l) { return l && l.t && l.u; });
    if (links.length) {
      out += '<div class="tw-sr__group"><p class="tw-sr__label">' + esc(CFG.linksTitle || 'Shop') + '</p><ul class="tw-sr__list">' + links.map(function (l) { return '<li><a class="tw-sr__row" href="' + esc(l.u) + '" data-tw-sr-item>' + icon(I_ARROW, 16) + '<span>' + esc(l.t) + '</span></a></li>'; }).join('') + '</ul></div>';
    }
    out += '</div><div class="tw-sr__main" data-tw-sr-startbox>' + (startHtml || '') + '</div>';
    intro.innerHTML = out;
    startBox = intro.querySelector('[data-tw-sr-startbox]');
    intro.classList.toggle('tw-sr__intro--bare', !startHtml);
  }
  function askStart() {
    if (startAsked) return;
    startAsked = true;
    var key = 'twsr:start:' + (CFG.v || '');
    try { var s = sessionStorage.getItem(key); if (s) { startHtml = s; if (intro && !shown) drawIntro(); return; } } catch (e) {}
    fetch((CFG.root || '/') + '?section_id=cro2610-search', { credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
      .then(function (text) {
        var el = new DOMParser().parseFromString(text, 'text/html').querySelector('[data-tw-sr-start]');
        startHtml = el ? el.innerHTML.trim() : '';
        try { if (startHtml) sessionStorage.setItem(key, startHtml); } catch (e) {}
        if (intro && !shown) drawIntro();
      })
      .catch(function () { startAsked = false; });
  }

  // ---- while typing
  function busy(on) { root.classList.toggle('is-busy', !!on); }
  function showIntro() {
    clearTimeout(timer);
    if (ctrl) { try { ctrl.abort(); } catch (e) {} }
    seq++;
    shown = '';
    busy(false);
    results.hidden = true;
    results.innerHTML = '';
    intro.hidden = false;
    drawIntro();
    statusEl.textContent = '';
  }
  function show(t, markup) {
    shown = t;
    busy(false);
    results.innerHTML = markup;
    var res = results.querySelector('[data-tw-sr-res]');
    var n = res ? +res.getAttribute('data-count') : 0;
    if (!n) {
      // nothing found: offer the popular searches and products instead of a dead end
      var terms = (CFG.terms || []).filter(Boolean);
      var extra = doc.createElement('div');
      extra.className = 'tw-sr__fallback';
      extra.innerHTML = (terms.length ? '<div class="tw-sr__group"><p class="tw-sr__label">' + esc(CFG.termsTitle || 'Popular searches') + '</p><div class="tw-sr__chips">' + terms.map(function (x) { return chip(x, '', I_SEARCH); }).join('') + '</div></div>' : '') + (startHtml ? '<div class="tw-sr__main">' + startHtml + '</div>' : '');
      results.appendChild(extra);
    }
    intro.hidden = true;
    results.hidden = false;
    body.scrollTop = 0;
    statusEl.textContent = n ? n + (n === 1 ? ' result' : ' results') + ' shown for ' + t : 'Nothing found for ' + t;
  }
  function ask(t) {
    if (ctrl) { try { ctrl.abort(); } catch (e) {} }
    ctrl = window.AbortController ? new AbortController() : null;
    var mine = ++seq;
    var url = (CFG.suggestUrl || '/search/suggest') + '?q=' + encodeURIComponent(t) + '&section_id=cro2610-search' +
      '&resources%5Btype%5D=' + encodeURIComponent(CFG.types || 'product,collection,query,page,article') +
      '&resources%5Blimit%5D=' + (CFG.limit || 8) + '&resources%5Blimit_scope%5D=each' +
      '&resources%5Boptions%5D%5Bunavailable_products%5D=last' +
      (CFG.fields ? '&resources%5Boptions%5D%5Bfields%5D=' + encodeURIComponent(CFG.fields) : '');
    fetch(url, { credentials: 'same-origin', signal: ctrl ? ctrl.signal : undefined })
      .then(function (r) { if (!r.ok) throw new Error('search ' + r.status); return r.text(); })
      .then(function (text) {
        var el = new DOMParser().parseFromString(text, 'text/html').querySelector('[data-tw-sr-res]');
        if (!el) throw new Error('search: no results block');
        cache[t.toLowerCase()] = el.outerHTML;
        if (mine === seq && isOpen) show(t, el.outerHTML);
      })
      .catch(function (err) {
        if (err && err.name === 'AbortError') return;
        if (mine !== seq) return;
        busy(false);
        // the list could not be fetched: Enter still goes to the full results page
        results.innerHTML = '<div class="tw-sr__none"><p class="tw-sr__none-title">Search is taking longer than usual</p><p class="tw-sr__none-text">Press Enter to see every result for &ldquo;' + esc(t) + '&rdquo;.</p></div>';
        intro.hidden = true;
        results.hidden = false;
        shown = '';
      });
  }
  function typed() {
    var t = term();
    clearBtn.hidden = !input.value;
    clearTimeout(timer);
    if (t.length < MIN) { showIntro(); return; }
    if (t === shown) { busy(false); return; }
    var hit = cache[t.toLowerCase()];
    if (hit) { seq++; show(t, hit); return; }
    busy(true);
    timer = setTimeout(function () { ask(t); }, WAIT);
  }
  function fill(t) {
    input.value = t;
    typed();
    // on a phone, leave the keyboard down after picking a ready-made search: the results are what matters now
    if (window.matchMedia && window.matchMedia('(hover: none)').matches) input.blur();
    else input.focus();
  }

  // ---- taps and keys inside the panel
  function clicked(e) {
    var t = e.target;
    if (!t.closest) return;
    if (t.closest('[data-tw-sr-close]')) { e.preventDefault(); close(); return; }
    var f = t.closest('[data-tw-sr-fill]');
    if (f) { e.preventDefault(); fill(f.getAttribute('data-tw-sr-fill')); return; }
    if (t.closest('[data-tw-sr-forget]')) { e.preventDefault(); forget(); drawIntro(); return; }
    var q = t.closest('[data-tw-sr-term]');
    if (q) { remember(q.getAttribute('data-tw-sr-term')); return; }
    if (t.closest('[data-tw-sr-item], [data-tw-sr-all]')) remember(term());
  }
  function items() {
    return Array.prototype.filter.call(root.querySelectorAll('[data-tw-sr-item], [data-tw-sr-fill], [data-tw-sr-all]'), function (el) { return el.offsetParent !== null; });
  }
  function keyed(e) {
    if (e.key === 'Escape') { e.preventDefault(); e.stopPropagation(); close(); return; }
    if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
      var list = items(), at = list.indexOf(doc.activeElement), next;
      if (!list.length) return;
      if (e.key === 'ArrowDown') next = at < 0 ? list[0] : list[Math.min(at + 1, list.length - 1)];
      else next = at <= 0 ? input : list[at - 1];
      e.preventDefault();
      next.focus();
      return;
    }
    if (e.key === 'Tab') {
      // keep the keyboard inside the panel while it is open
      var f = Array.prototype.filter.call(root.querySelectorAll('a[href], button:not([hidden]), input:not([type="hidden"])'), function (el) { return el.offsetParent !== null; });
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && doc.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && doc.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  }

  // ---- open and close
  function open(prefill) {
    if (!root) build();
    if (isOpen) { try { input.focus({ preventScroll: true }); } catch (e) { input.focus(); } return; }
    isOpen = true;
    lastFocus = doc.activeElement;
    // the stylesheet is fetched without holding the page up; make sure it applies from now on
    var css = doc.getElementById('twSearchCss');
    if (css && css.media !== 'all') css.media = 'all';
    var gap = window.innerWidth - html.clientWidth;
    if (gap > 0) doc.body.style.paddingRight = gap + 'px';
    html.classList.add('tw-sr-open');
    root.hidden = false;
    if (typeof prefill === 'string') input.value = prefill;
    // focus inside the tap itself: that is what brings the keyboard up on a phone
    try { input.focus({ preventScroll: true }); } catch (e) { input.focus(); }
    fit();
    if (term().length >= MIN) typed(); else showIntro();
    clearBtn.hidden = !input.value;
    askStart();
    requestAnimationFrame(function () { requestAnimationFrame(function () { root.classList.add('is-in'); }); });
    if (typeof window.cro2610EndFade === 'function') { try { window.cro2610EndFade(); } catch (e) {} }
  }
  function close() {
    if (!isOpen) return;
    isOpen = false;
    clearTimeout(timer);
    root.classList.remove('is-in');
    html.classList.remove('tw-sr-open');
    doc.body.style.paddingRight = '';
    try { input.blur(); } catch (e) {}
    setTimeout(function () { if (!isOpen) root.hidden = true; }, 200);
    if (lastFocus && lastFocus.focus && doc.contains(lastFocus)) { try { lastFocus.focus({ preventScroll: true }); } catch (e) {} }
  }

  // ---- what opens it
  // The header's search icon; the phone menu's "Search plants, pots and care" button (it also closes the menu and
  // presses the icon a moment later, which finds the panel already open); anything marked data-tw-search-open.
  doc.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    if (t.closest('#twSearch')) return;
    var trigger = t.closest('#searchIcon, [data-tw-search-open]');
    if (trigger) { e.preventDefault(); e.stopPropagation(); open(); return; }
    if (t.closest('.tw-mm__search')) open();
  }, true);
  doc.addEventListener('keydown', function (e) {
    if (isOpen) return;
    var k = e.key;
    var typing = /^(INPUT|TEXTAREA|SELECT)$/.test((e.target && e.target.tagName) || '') || (e.target && e.target.isContentEditable);
    if ((k === '/' && !typing && !e.metaKey && !e.ctrlKey && !e.altKey) || ((k === 'k' || k === 'K') && (e.metaKey || e.ctrlKey) && !e.shiftKey && !e.altKey)) {
      e.preventDefault();
      open();
    }
  });
  // have the popular products ready as soon as the pointer or a finger reaches the icon
  function warm(e) { var t = e.target; if (t && t.closest && t.closest('#searchIcon, .tw-mm__search, [data-tw-search-open]')) askStart(); }
  doc.addEventListener('pointerover', warm, { passive: true });
  doc.addEventListener('touchstart', warm, { passive: true });
  // a page brought back by the Back button must not come back with the panel open
  window.addEventListener('pageshow', function (e) { if (e.persisted && isOpen) close(); });

  function ready() { build(); }
  if (doc.body) ready(); else doc.addEventListener('DOMContentLoaded', ready);
  window.cro2610Search = { open: open, close: close };
})();
